export default {"src":"/_next/static/media/ic-invoice.89cd151d.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};